import { put, takeEvery, takeLatest, all, fork } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { incrementByAmount } from '../reducer/counterSlice';
import {
  availableCardsRequest,
  signInRequest,
  signInSuccess,
  signOutRequest,
  passkeySignInRequest,
} from '../reducer/userSlice';
import { signInSaga } from './signInSaga';
import { passkeySignInSaga } from './passkeySignInSaga';
import { fetchAccountDetailsSaga } from './accountDetailsSaga';
import { fetchRewardsSaga } from './rewardsSaga';
import { rewardsRequest } from '../reducer/rewardsSlice';
import {
  transactionRequest,
  eppOptionsRequest,
} from '../reducer/transactionsSlice';
import { accountRequest } from '../reducer/accountSlice';
import { fetchTransactionSaga, fetchEppOptionsSaga } from './transactionSaga';
import { useraccountDetailsRequest } from '../reducer/userAccountDeatilsSlice';
import { getAccountDetailsSaga } from './accountSaga';
import { eppRequest } from '../reducer/eppSlice';
import { getEPPDetailsSaga } from './eppSaga';
import {
  fetchCardLockStatusRequest,
  updateCardLockStatusRequest,
} from '../reducer/cardLockSlice';
import {
  fetchCardLockStatusSaga,
  updateCardLockStatusSaga,
} from './cardLockSaga';
import { fetchInitiateStatementSaga, fetchJobStatusStatementSaga, fetchStatementsSaga, fetchViewStatementSaga } from './statementsSaga';
import {
  initiateStatementRequest,
  jobStatementRequest,
  statementsRequest,
  statementViewRequest,
} from '../reducer/statementsSlice';
import { transactionsDownloadRequest } from '../reducer/transactionsDownloadSlice';
import { handleTransactionsDownload } from './tranksactionsDownloadSaga';
import { fetchContactDetailsSaga } from './contactDetailsSaga';

import { preferencesUserRequest } from '../reducer/preferencesUserSlice';

import { fetchPreferencesUserRequestSaga } from './preferencesUserSaga';

import { generateCodeForDeviceRequest } from '../reducer/generateCodeDeviceSlice';
import { fetchGenerateCodeDeviceRequestSaga } from './generateCodeForDeviceSaga';
import { signOutSaga } from './signOutSaga';
import {
  myProfileStatesRequest,
  updateAddressRequest,
  emailAddressDetailsRequest,
  updateEmailAddressRequest,
  phoneDetailsRequest,
  updatePhoneRequest,
  updateLanguageRequest,
} from '../reducer/myProfileSlice';
import {
  addressUpdateSaga,
  fetchAddressStatesSaga,
  fetchEmailDetailsSaga,
  fetchPhoneNumberSaga,
  updateEmailDetailsSaga,
  updateLanguageSaga,
  updatePhoneNumberSaga,
} from './myProfileSaga';
import { fetchActiveAlertsSaga } from './manageAlertsSaga';
import {
  fetchActiveAlertsRequest,
  fetchAlertContactPreferencesRequest,
  updateAlertPreferencesRequest,
} from '../reducer/manageAlertsSlice';
import {
  fetchAlertContactPreferencesSaga,
  updateAlertPreferencesSaga,
  fetchPhoneOptionsSaga,
  updatePhoneForAlertsSaga,
  updateAlertContactPreferencesSaga,
} from './manageAlertsSaga';
import {
  fetchPhoneOptionsRequest,
  updatePhoneForAlertsRequest,
} from '../reducer/manageAlertsSlice';
import {
  fetchEmailOptionsRequest,
  updateEmailForAlertsRequest,
} from '../reducer/manageAlertsSlice';
import {
  fetchEmailOptionsSaga,
  updateEmailForAlertsSaga,
} from './manageAlertsSaga';
import { updateAlertContactPreferencesRequest } from '../reducer/manageAlertsSlice';
import { sendVerificationTextRequest } from '../reducer/smsVerificationSlice';
import { sendSmsVerificationSaga } from './smsVerificationSaga';


export function* incrementAsync(action: PayloadAction<number>) {
  yield new Promise((resolve) => setTimeout(resolve, 1000));
  yield put(incrementByAmount(action.payload));
}

export function* rootSaga() {
  yield all([fork(watchIndividualSagas)]);
}

// Individual sagas watcher
function* watchIndividualSagas() {
  yield takeEvery('counter/incrementAsync', incrementAsync);
  yield takeLatest(signInRequest?.type, signInSaga);
  yield takeLatest(passkeySignInRequest.type, passkeySignInSaga);
  yield takeLatest(signInSuccess.type, fetchAccountDetailsSaga);
  yield takeLatest(rewardsRequest.type, fetchRewardsSaga);
  yield takeLatest(transactionRequest.type, fetchTransactionSaga);
  yield takeLatest(eppOptionsRequest.type, fetchEppOptionsSaga);
  yield takeLatest(useraccountDetailsRequest.type, fetchAccountDetailsSaga);
  yield takeLatest(accountRequest.type, getAccountDetailsSaga);
  yield takeLatest(eppRequest.type, getEPPDetailsSaga);
  yield takeLatest(fetchCardLockStatusRequest.type, fetchCardLockStatusSaga);
  yield takeLatest(updateCardLockStatusRequest.type, updateCardLockStatusSaga);
  yield takeLatest(signOutRequest?.type, signOutSaga);
  yield takeLatest(
    preferencesUserRequest.type,
    fetchPreferencesUserRequestSaga
  );
  yield takeLatest(
    generateCodeForDeviceRequest.type,
    fetchGenerateCodeDeviceRequestSaga
  );
  yield takeLatest(statementsRequest.type, fetchStatementsSaga);
  yield takeLatest(initiateStatementRequest.type, fetchInitiateStatementSaga);
  yield takeLatest(jobStatementRequest.type, fetchJobStatusStatementSaga);
  yield takeLatest(statementViewRequest.type, fetchViewStatementSaga);
  yield takeEvery(transactionsDownloadRequest.type, handleTransactionsDownload);
  yield takeEvery(availableCardsRequest.type, fetchContactDetailsSaga);
  yield takeLatest(myProfileStatesRequest.type, fetchAddressStatesSaga);
  yield takeLatest(updateAddressRequest.type, addressUpdateSaga);
  yield takeLatest(emailAddressDetailsRequest.type, fetchEmailDetailsSaga);
  yield takeLatest(updateEmailAddressRequest.type, updateEmailDetailsSaga);
  yield takeLatest(phoneDetailsRequest.type, fetchPhoneNumberSaga);
  yield takeLatest(updatePhoneRequest.type, updatePhoneNumberSaga);
  yield takeLatest(updateLanguageRequest.type, updateLanguageSaga);
  yield takeLatest(fetchActiveAlertsRequest.type, fetchActiveAlertsSaga);
  yield takeLatest(
    fetchAlertContactPreferencesRequest.type,
    fetchAlertContactPreferencesSaga
  );
  yield takeLatest(
    updateAlertPreferencesRequest.type,
    updateAlertPreferencesSaga
  );
  yield takeLatest(fetchPhoneOptionsRequest.type, fetchPhoneOptionsSaga);
  yield takeLatest(updatePhoneForAlertsRequest.type, updatePhoneForAlertsSaga);
  yield takeLatest(fetchEmailOptionsRequest.type, fetchEmailOptionsSaga);
  yield takeLatest(updateEmailForAlertsRequest.type, updateEmailForAlertsSaga);
  yield takeLatest(
    updateAlertContactPreferencesRequest.type,
    updateAlertContactPreferencesSaga
  );
  yield takeLatest(sendVerificationTextRequest.type, sendSmsVerificationSaga);

  //yield* banLinkageSaga();
}
